module.exports = __webpack_public_path__ + "img/custom-right-arrow.11eb543a.svg";